<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail input-scan-page" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Work Order Execution Hold Time">
		<b-card>
			<b-row>
				<b-col cols="12" lg="12">
					<app-label v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''" label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
                    <new-date-time-picker label-cols-lg="1" :model="startTime" @update:model="updateStartTime" label="Start Time" />
                    <new-date-time-picker label-cols-lg="1" :model="endTime" @update:model="updateEndTime" label="End Time" />
                    <app-input-textbox id="fieldset-duration" label-cols-lg="2"  label="Remark" label-for="input-duration" size="sm" :model.sync="activeModel.remark" />
                    
				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import focusInput from '@/mixins/focusInputMixin';
import WorkOrderExecutionControlTime from '@/models/WorkOrderExecution/WorkOrderExecutionControlTime';
import WorkOrderExecutionControlTimeFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionControlTimeFilter';

import WorkOrderExecutionHoldTime from '@/models/WorkOrderExecutionHoldTime/WorkOrderExecutionHoldTime';
import WorkOrderExecutionHoldTimeFilter from '@/filters/WorkOrderExecutionHoldTime/WorkOrderExecutionHoldTimeFilter';

import WorkOrderExecution from '@/models/WorkOrderExecution/WorkOrderExecution';
import WorkOrderExecutionFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ProblemCategory from '@/models/ProblemCategory/ProblemCategory';
import ProblemCategoryFilter from '@/filters/ProblemCategory/ProblemCategoryFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import PopupRouterView from '@/components/PopupRouterView';
import AppInputScan from '@/components/AppInputScan';
import AppInputTextbox from '@/components/AppInputTextbox';
import NewDateTimePicker from '@/components/AppInputDateTimePickerCustomPineda.vue';
export default {
	props: ['model','modelId', 'openPopup','addButtonMethod', 'resetMethod', 'parentLabelInfo', 'parentValueInfo', 'woeId'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		PopupRouterView,
		AppInputScan,
        AppInputTextbox,
		NewDateTimePicker,
	},
	mixins : [validationMixin, focusInput],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			ngCategories : [],
			isBusy: false,
			activeModel: {
				startTime: null,
				endTime: null,
				remark: '',
			},
			startTime: null,
			endTime: null,
		}
	},
	methods : {
		async updateStartTime(newValue) {
			this.activeModel.startTime = newValue;
			return;
		},
		async updateEndTime(newValue) {
			this.activeModel.endTime = newValue;
			return;
		},
		getWorkOrderExecutionControlTime : async function(id) {
			this.isBusy = true;
			await WorkOrderExecutionHoldTime.getData(this, id).then(result => {
				this.activeModel = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.startTime = null;
				this.endTime = null;
				let model = this.activeModel;
				let promises = Array();
				console.log("woedId", this.woeId);
				model.workOrderExecutionId = this.woeId;
					
				Promise.all(promises).then((results) => {
					this.$emit("addButtonMethod", modalEvent, model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.activeModel = {};
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getNgCategories();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getWorkOrderExecutionControlTime(newValue);
			} else {
				this.activeModel = {};
			}
		},
		openPopup(newValue) {
			console.log("toggle modal", newValue);
			console.log("activeModel", this.activeModel);
			if (newValue) {
				//this.getNgCategories();
				if(this.model != null || this.model != undefined) {
					this.activeModel = this.model;
				} else {
					this.activeModel = {};
				}

				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getWorkOrderExecutionControlTime(this.modelId);
				}
			} else {
				this.activeModel = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				console.log("this.openpopup", this.openPopup);
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
